

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEAPPRAISALYEAR= createAsyncThunk(
  "createAppraisalYear/createAppraisalYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createAppraisalYearSlice = createSlice({
  name: "createAppraisalYearSlice",
  initialState: {
    createAppraisalYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateAppraisalYear: (state) => {
        state.createAppraisalYear.loading = false
        state.createAppraisalYear.error = false
        state.createAppraisalYear.data = []
        state.createAppraisalYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEAPPRAISALYEAR.fulfilled, (state, action) => {
      state.createAppraisalYear = {
        ...state.createAppraisalYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEAPPRAISALYEAR.pending, (state, action) => {
      state.createAppraisalYear = {
        ...state.createAppraisalYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEAPPRAISALYEAR.rejected, (state, action) => {
      state.createAppraisalYear = {
        ...state.createAppraisalYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createAppraisalYearAction = {
    CREATEAPPRAISALYEAR,
};

export { createAppraisalYearAction };
export default createAppraisalYearSlice.reducer;
export const {setInitialStateOfcreateAppraisalYear} = createAppraisalYearSlice.actions
